import { CurrencyUnit } from '../types/Currency/Currency.types';
import { CountryCode } from '../types/CountryCode/CountryCode.types';
import { TransferKind } from '../../containers/AddBankAccountContainer/AddBankAccountContainer.types';

const eurCountries = ['AT', 'FR', 'IT', 'DE', 'ES'];
export const getTransferKind = (
  countryCode: string,
  currency?: CurrencyUnit,
): TransferKind => {
  if (countryCode === 'US' && currency === CurrencyUnit.USD)
    return CountryCode.US;
  if (countryCode === 'GB' && currency === CurrencyUnit.GBP)
    return CountryCode.UK;
  if (eurCountries.includes(countryCode) && currency === CurrencyUnit.EUR)
    return CountryCode.EU;
  if (countryCode === 'SE' && currency === CurrencyUnit.SEK)
    return CountryCode.EU;
  if (countryCode === 'CH' && currency === CurrencyUnit.CHF)
    return CountryCode.EU;
  return 'UNSUPPORTED';
};
